module.exports = __webpack_public_path__ + "static/img/qrl.cb6804ac.png";